import { Component, Input } from '@angular/core';
import { ICDADetailed } from 'src/app/interfaces/SHL/ICDADetailed';
import { SHLService } from 'src/app/services/shl.service';
import { SwalToastService } from 'src/app/services/swal.service';

@Component({
  selector: 'app-shl-patient-summary',
  templateUrl: './shl-patient-summary.component.html',
  styleUrls: ['./shl-patient-summary.component.css'],
  standalone: false,
})
export class ShlPatientSummaryComponent {
  @Input() data?: ICDADetailed;
  @Input() isLoading: boolean = false;
  @Input() location?: string;

  isVisible: boolean = false;

  constructor(
    private readonly shlService: SHLService,
    private readonly swalToastService: SwalToastService
  ) {}

  loadDetails() {
    this.isVisible = true;
  }

  handleCancel() {
    this.isVisible = false;
  }

  formatDate(dateString: string | null): string {
    if (!dateString) return '-';

    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    return `${year}-${month}-${day}`;
  }

  downloadCDA() {
    if (this.location) {
      this.shlService.downloadSHL(this.location).subscribe({
        next: (xmlString: string) => {
          const blob = new Blob([xmlString], { type: 'application/xml' });
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = 'SmartHealthLink.xml';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          window.URL.revokeObjectURL(url);
        },
        error: (error) => {
          this.swalToastService.toastError(
            error.error?.message || 'Failed to download the CDA.'
          );
        },
      });
    }
  }
}
